import { FC, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import useBasePath from "src/utils/hooks/useBasePath";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import { absencesEmployeeAbsenceRecordsWrite } from "src/utils/RoleBasedSecurity/permissions";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import __ from "src/utils/Translations";
import Title from "src/Pages/Company/Absences/Title/Title";
import AbsenceRecordsEmployeesTable from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecordsEmployeesTable";
import PermissionsAlert from "src/Pages/Company/Absences/PermissionsAlert";

const AbsenceRecords: FC = () => {
  const basePath = useBasePath();
  const canWriteAbsenceRecords = usePermission(
    absencesEmployeeAbsenceRecordsWrite
  );

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    },
    []
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Kartoteki pracowników"),
          },
        ]}
      />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Title
          title={__("Kartoteki pracowników")}
          subtitle={__(
            "Przestrzeń do jednostkowego zarządzania nieobecnościami i statusami obecności u pracowników."
          )}
        />
        {canWriteAbsenceRecords && (
          <>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleClick}
              startIcon={<SettingsOutlined />}
              endIcon={<ArrowDropDown />}
              sx={{ height: "fit-content", alignSelf: "center" }}
              data-testid="import-export-button"
            >
              {__("Import i eksport")}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "bulk-update-button",
              }}
              data-testid="import-export-menu"
            >
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={`${basePath}/absences/import-calendars`}
                data-testid="import-export-menu__calendars"
              >
                {__("Kalendarze pracowników")}
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={Link}
                to={`${basePath}/absences/import-patterns`}
                data-testid="import-export-menu__patterns"
              >
                {__("Wymiary i wzorce urlopowe")}
              </MenuItem>
            </Menu>
          </>
        )}
      </Box>
      {!canWriteAbsenceRecords && <PermissionsAlert />}
      <AbsenceRecordsEmployeesTable />
    </>
  );
};

export default AbsenceRecords;
